import { render, staticRenderFns } from "./StampingQr.vue?vue&type=template&id=2549f64f&scoped=true"
import script from "./StampingQr.vue?vue&type=script&lang=ts"
export * from "./StampingQr.vue?vue&type=script&lang=ts"
import style0 from "./StampingQr.vue?vue&type=style&index=0&id=2549f64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549f64f",
  null
  
)

export default component.exports